module.exports = __webpack_public_path__ + "img/magazine26.93957a30.jpg";